import { baseHealthManagementBarriersToHealthStatus, baseHealthManagementHomeEnvironment, baseHealthManagementMedications, baseHealthManagementSignsOfHeartFailure, baseHealthManagementSignsOfOtherComorbidity, baseHealthManagementSuspectedAbuse, } from '../validations/shared/health-management';
const medShape = baseHealthManagementMedications.shape;
const homeShape = baseHealthManagementHomeEnvironment.shape;
const abuseShape = baseHealthManagementSuspectedAbuse.shape;
const barriersShape = baseHealthManagementBarriersToHealthStatus.shape;
const hfShape = baseHealthManagementSignsOfHeartFailure.shape;
const comorbidityShape = baseHealthManagementSignsOfOtherComorbidity.shape;
export const medActionFields = [
    { key: 'actions', field: medShape.actions, variant: 'tags' },
];
export const medIssueFields = [
    { key: 'issues', field: medShape.issues, variant: 'tags' },
    { key: 'issuesDescription', field: medShape.issuesDescription },
    { key: 'issuesNotifications', field: medShape.issuesNotifications, variant: 'tags' },
];
export const homeDetailFields = [
    { key: 'details', field: homeShape.details, variant: 'tags' },
];
export function buildAbuseTypeFields(showOther) {
    return [
        { key: 'types', field: abuseShape.types, variant: 'tags' },
        ...(showOther ? [{ key: 'otherDescription', field: abuseShape.otherDescription }] : []),
    ];
}
export const barrierFields = [
    { key: 'barriers', field: barriersShape.barriers, variant: 'tags' },
];
export const hfFields = [
    { key: 'actions', field: hfShape.actions, variant: 'tags' },
    { key: 'comment', field: hfShape.comment },
];
export const comorbidityFields = [
    { key: 'actions', field: comorbidityShape.actions, variant: 'tags' },
    { key: 'comment', field: comorbidityShape.comment },
];
